export const COWORKING_DAY_PASS_PATH = '/coworking-day-pass/:id';
